export default data => {
    return data && data.lista 
        ? data.lista 
        : [];
}
